import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class CalculationsService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getCalcInfo(calcNames) {
        const url = this.urlsService.getUrl(this.urlsService.CALCULATIONS.CALC_INFO, {}, { calcs: calcNames.join(',') });
        return this.ajaxService.getDataObserveBody(url);
    }
    getSavedScores() {
        const url = this.urlsService.getUrl(this.urlsService.CALCULATIONS.SAVED_SCORE_COLLECTION);
        return this.ajaxService.getDataObserveBody(url);
    }
    postSavedScore(serializedScore) {
        const url = this.urlsService.getUrl(this.urlsService.CALCULATIONS.SAVED_SCORE_COLLECTION);
        return this.ajaxService.postJsonDataObserveBody(url, serializedScore);
    }
    putSavedScore(scoreId, serializedScore) {
        const url = this.urlsService.getUrl(this.urlsService.CALCULATIONS.SAVED_SCORE, { scoreId });
        return this.ajaxService.putDataObserveBody(url, serializedScore);
    }
    deleteSavedScore(scoreId) {
        const url = this.urlsService.getUrl(this.urlsService.CALCULATIONS.SAVED_SCORE, { scoreId });
        return this.ajaxService.deleteDataObserveBody(url);
    }
    getMetricRangeInfo(securityGroup, metrics) {
        const url = this.urlsService.getUrl(this.urlsService.CALCULATIONS.METRIC_RANGE_INFO, {
            securityGroup,
            metrics,
        });
        return this.ajaxService.getDataObserveBody(url);
    }
}
CalculationsService.ɵfac = function CalculationsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CalculationsService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
CalculationsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CalculationsService, factory: CalculationsService.ɵfac, providedIn: 'root' });
